/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SearchUserResult } from '@models';
import { LocalStorageService } from 'src/app/services/local-storage/local-storage/local-storage.service';
import { ProductsService } from 'src/app/services/products/products.service';

// Dialog box to show the last 10 customers an internal user has selected from search restuls
@Component({
  selector: 'wsn-recent-customers',
  templateUrl: './recent-customers.component.html',
  styleUrls: ['./recent-customers.component.scss']
})
export class RecentCustomersComponent implements OnInit {
  recentCustomers: SearchUserResult[] = [];
  selectedCustomer: SearchUserResult = undefined;

  constructor(
    public dialogRef: MatDialogRef<RecentCustomersComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private productService: ProductsService,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    this.recentCustomers = this.localStorageService.getRecentUsers();
  }

  onClickCustomer(selectedResult: SearchUserResult) {
    this.selectedCustomer = selectedResult;
  }

  selectCustomer() {
    this.localStorageService.addRecentUser(this.selectedCustomer);
    this.dialogRef.close(this.selectedCustomer);
  }

  cancel() {
    this.dialogRef.close({});
  }
}
